import * as React from "react";
import ProjectOverviewGrid from "./ProjectOverviewGrid/ProjectOverviewGrid";

export default function ProjectOverview() {
  return <ProjectOverviewGrid />;
}
